import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import database from './repository/database';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  database,
  render: h => h(App),
}).$mount('#app');

// https://vuetifyjs.com/en/introduction/why-vuetify/
